import React from 'react';
import ColumnsPopover from 'features/agent-analytics/components/ColumnsPopover';
import { CONFIGURABLE_RUN_COLUMNS, DEFAULT_RUN_COLUMN_KEYS } from 'features/agent-analytics/utils/runColumns';

/**
 * Edit-columns control for the Runs table. The popup itself is shared with the
 * Spans table — see ColumnsPopover, which added the drag-to-reorder the
 * Activity tables have always had.
 */
export default function AgentRunsColumnsButton({ columnKeys, onChange }) {
  return (
    <ColumnsPopover
      columns={CONFIGURABLE_RUN_COLUMNS}
      columnKeys={columnKeys}
      defaultKeys={DEFAULT_RUN_COLUMN_KEYS}
      onChange={onChange}
    />
  );
}
